import { ComponentMeta } from "../context/context";
import { DyGridRegisteredComponentInput } from "../components/framework/userComponentRegistry";
import { IComponent } from "./iComponent";
import { IRowModel } from "./iRowModel";

export interface Module {
  moduleName: string;
  beans?: any[];
  dyStackComponents?: ComponentMeta[];
  userComponents?: { componentName: string, componentClass: DyGridRegisteredComponentInput<IComponent<any>> }[];
  rowModels?: { [name: string]: { new(): IRowModel } };
  dependantModules?: Module[];
}
